import { render, staticRenderFns } from "./details.vue?vue&type=template&id=e8513bcc&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=e8513bcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8513bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8513bcc')) {
      api.createRecord('e8513bcc', component.options)
    } else {
      api.reload('e8513bcc', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=e8513bcc&scoped=true", function () {
      api.rerender('e8513bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/device-identity-auth/white-list/details.vue"
export default component.exports